module.exports = __webpack_public_path__ + "img/cakie-the-cake-monster.453db96c.jpg";